<!--
 * @Description: 外加剂返料审批
 * @Author: wangwangwang
 * @Date: 2020-11-18 15:34:16
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-05-21 11:10:11
-->
<template>
  <div class="flows-content">
    <el-container>
      <el-main style="margin-bottom: 20px; padding: 0;">
        <el-container direction="vertical">
          <FlowHeader :isReadOnly="readOnly" @saveSubmit="handleSubmit(1)" @sendSubmit="handleSubmit(2)" @handleBackEnd="handleSubmit(3)" @handleCC="handleSubmit(4)" @handleAssign="handleSubmit(5)" @handleBackUp="handleSubmit(6)" @handleAssist="handleSubmit(7)" @handleNode="handleSubmit(8)" @handleNodeImage="handleSubmit(9)" @handleCollection="handleSubmit(10)" />
          <el-main class="info">
            <div>
              <el-input v-model="title" class="flow-title" :disabled="$route.query.type*1!==1" placeholder="请输入流程标题"></el-input>
            </div>
            <div class="info-top">
              <div class="left">
                <span>单据号码：{{billCode}}</span>
                <span class="text">制单日期：{{billDate}}</span>
              </div>
              <div class="right">
                <span>发起人：{{applyPerson}}</span>
                <span class="text">状态：{{taskTypeText[taskStatus*1]}}</span>
              </div>
            </div>
            <div class="content">
              <div>
                <el-form ref="reffrom1" :inline="true" :model="fromDate" label-width="140px">
                  <el-form-item prop="stationId">
                    <span slot="label">站点：</span>
                    <div style="width:290px;">{{fromDate.station}}
                      <span v-if="fromDate.oldData.station&&(fromDate.station!==fromDate.oldData.station)" class="delete-line">{{fromDate.oldData.station}}</span>
                    </div>
                  </el-form-item>
                  <el-form-item prop="updateTime">
                    <span slot="label">特材成品：</span>
                    <div style="width:290px;">{{fromDate.productName}}
                      <span v-if="fromDate.oldData.productName&&(fromDate.productName!==fromDate.oldData.productName)" class="delete-line">{{fromDate.oldData.productName}}</span>
                    </div>
                  </el-form-item>
                  <el-form-item prop="warehouseId">
                    <span slot="label">型号：</span>
                    <div style="width:290px;">{{fromDate.productType}}
                      <span v-if="fromDate.oldData.productType&&(fromDate.productType!==fromDate.oldData.productType)" class="delete-line">{{fromDate.oldData.productType}}</span>
                    </div>
                  </el-form-item>
                  <el-form-item prop="warehouseId">
                    <span slot="label">返料量：</span>
                    <div style="width:290px;">{{fromDate.returnNum}}
                      <span v-if="fromDate.oldData.returnNum&&(fromDate.returnNum!==fromDate.oldData.returnNum)" class="delete-line">{{fromDate.oldData.returnNum}}</span>
                    </div>
                  </el-form-item>
                  <el-form-item prop="remark">
                    <span slot="label">备注：</span>
                    <div style="width: 660px">{{fromDate.remark}}
                      <span v-if="fromDate.oldData.remark&&(fromDate.remark!==fromDate.oldData.remark)" class="delete-line">{{fromDate.oldData.remark}}</span>
                    </div>
                  </el-form-item>
                </el-form>
              </div>
            </div>
            <div class="flows-details">
              <FlowContent ref="flowcontent" :title='title' :showSendVisible="showSendVisible" @handleCancel="handleCancel" @sendCode="sendCode" @handleFinish="handleFinish" @handleBusiness="handleBusiness" @submitData="submitDataType"  @resetFlowState="resetFlowState"/>
            </div>
          </el-main>
        </el-container>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import FlowContent from '@/components/WorkFlow/flowContent';
import FlowHeader from '@/components/WorkFlow/flowHeader';
import { updataData } from '@/api/smart/warehouse/ADRN';
import { getUserInfo } from "@/utils/auth.js";
export default {
  components: {
    FlowContent,
    FlowHeader,
  },
  data() {
    return {
      type: 0,
      title: '外加剂返料审批',
      billCode: '',
      billDate: '',
      applyPerson: '',
      taskTypeText: ['发起', '已保存', '审批中', '已完成', '撤销', '不通过'],
      taskStatus: 0,
      showSendVisible: false,
      readOnly: false,
      titlestatus: null,
      fromDate: {
        returnNum: '',
        oldData: {},
      }
    }
  },
  methods: {
    submitDataType() {
      if (this.fromDate.id) {
        updataData({
          id: this.fromDate.id,
          dataStatus: 3,
        });
      } else {
        updataData({...this.fromDate,dataStatus: 3});
      }
    },
    resetFlowState (type) {
      updataData({
        id: this.fromDate.id,
        dataStatus: type===1?4:5, 
      });
    },
    handleBusiness() {
      const { query } = this.$route;
      const params = {
        process_success: {
          url: '/icps/system/sign/intelligent/warehouse/return/saveOrUpdate',
          data: {
            ...JSON.parse(JSON.parse(query.dataContent).id),
          },
          httpMethod: 'post',
        },
        process_failure: ''
      }
      this.showSendVisible = false;
      this.$refs.flowcontent.handleToFlow(params);
    },
    handleFinish() {
    },
    handleSubmit(type) {
      const { query } = this.$route;
      if (query.type * 1 === 2 && type === 2 && query.taskType*1 !== 2) { // 发起流程
        this.showSendVisible = true;
        return
      }
      const data = {
        dataSource: 'sign_ADRN',
        dataContent: JSON.stringify({ id: query.id, oldData: this.fromDate.oldData }), // 业务数据
      }
      this.$refs.flowcontent.saveFlows(type, data);
    },
    handleFlowChat() {
      this.$refs.flowcontent.showFlowNode()
    },
    handleCancel() {
      this.showSendVisible = false;
    },
    sendCode(code) {
      this.billCode = code;
    },
  },
  created() {
    const { query } = this.$route;
    this.titlestatus = Number(query.type)
  },
  mounted() {
    const { query } = this.$route;
    if (query.type * 1 === 1) { // 发起流程
      this.$refs.flowcontent.initBaseData('sign_ADRN');
      this.billDate = new Date().Format('yyyy-MM-dd hh:mm:ss');
      this.fromDate = {...JSON.parse(query.id), oldData: JSON.parse(query.oldData)};
      this.applyPerson = getUserInfo().userRealName;
      return
    }
    console.log()
    this.fromDate = {...JSON.parse(JSON.parse(query.dataContent).id), oldData: JSON.parse(query.dataContent).oldData}
    console.log(this.fromDate)
    this.title = query.taskName;
    this.billCode = query.receiptNumber;
    this.billDate = query.createTime;
    this.applyPerson = query.createUserName;
    this.taskStatus = query.taskStatus;
    if (query.isReadOnly*1===1) {
      this.readOnly = true;
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  @include discen;
  width: auto;
  > div {
    margin-top: 50px;
    width: 923px;
    border: 1px solid #e1e5ed;
    border-radius: 4px;
    padding: 20px;
  }
}
.flows-details {
  margin-top: 20px;
}
.info {
  padding: 0 20px;
  background: #fff;
  .info-top {
    font-size: $font_size;
    color: #000000;
    @include discen_al;
    justify-content: space-between;
    height: 50px;
    border-top: 1px #e1e5ed solid;
    border-bottom: 1px #e1e5ed solid;
    .left {
      @include discen_al;
    }
    .text {
      margin-left: 60px;
    }
  }
}
.nav_title {
  @include discen_al;
  align-items: flex-end;
  > div {
    width: 4px;
    height: 24px;
    background: $bg_color;
    margin-right: 10px;
  }
  i {
    margin-left: 5px;
  }
  color: $bg_color;
  font-size: 20px;
  font-weight: bold;
}
.dialoginfo {
  padding: 0;
}
.active {
  border-top: 1px #e1e5ed solid;
  border-right: 1px #e1e5ed solid;
  border-left: 1px #e1e5ed solid;
  background: #fff;
}
.dialoginfo-info {
  border-right: 1px #e1e5ed solid;
  border-left: 1px #e1e5ed solid;
  border-bottom: 1px #e1e5ed solid;
}
/*弹窗*/
.dialoginfo-title {
  > div {
    cursor: pointer;
  }
  height: 48px;
  display: flex;
  background: linear-gradient(
    180deg,
    rgba(250, 252, 255, 1) 0%,
    rgba(245, 247, 250, 1) 100%
  );
  .none {
    font-weight: bold;
    height: 48px;
    @include discen;
    width: calc(calc(100% - 1px) / 2);
    border-bottom: 1px solid #e1e5ed;
    > div {
      line-height: 48px;
      border-bottom: 1px rgba(0, 0, 0, 0) solid;
    }
  }
  .center {
    width: 1px;
    height: 48px;
    background: #e1e5ed;
  }
  .active {
    font-weight: bold;
    height: 48px;
    @include discen;
    width: calc(calc(100% - 1px) / 2);
    border-bottom: 1px solid rgba(0, 0, 0, 0);
    > div {
      color: $bg_color;
      line-height: 48px;
      border-bottom: 1px $bg_color solid;
    }
  }
}
.dialoginfo-info {
  padding: 10px 20px;
  overflow: auto;
  height: calc(85vh - 282px);
  .el-select,
  .el-input,
  .el-date-picker {
    width: 100%;
  }
}
.form-title {
  font-size: 18px;
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
}
</style>